import Vue from 'vue'

import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

import VueUtilsMixin from './mixins/VueUtilsMixin'
Vue.mixin(VueUtilsMixin)

import VueRouteMixin from './mixins/VueRouteMixin'
Vue.mixin(VueRouteMixin)

import VueSelect from './components/VueSelect'
Vue.component('vue-select', VueSelect)

import SvgIcon from './components/SvgIcon'
Vue.component('svg-icon', SvgIcon)

import ProductCounter from './components/ProductCounter/ProductCounter'
Vue.component('product-counter', ProductCounter)

import PriceFormatted from './components/PriceFormatted/PriceFormatted'
Vue.component('price-formatted', PriceFormatted)
